import WrappedLogin_ from './routes/login/Login'
import MyOb1_ from './routes/MyObservationChecklist/MyObservation'
import Summary_ from './routes/summary/Summary'
import Feedback_myself_ from './routes/feedback/Feedback_myself'
import Feedback_all_ from './routes/feedback/Feedback_all'
import Feedbackdetail_ from './routes/feedback/Feedbackdetail'
import Feedback_new_ from './routes/feedback/Newfeedback'
import UserMD_ from './routes/systemmanagement/UserMD'
import Newobservation_Basic_Info_ from './routes/Newobservation/Basic_info'
import Newobservation_Checklist_ from './routes/Newobservation/Checklist'
import Newobservation_Category_ from './routes/Newobservation/Checklist/Category'
import Newobservation_Action_ from './routes/Newobservation/Action'
import Newobservation_Summary_ from './routes/Newobservation/Summary'
import Profile_ from './routes/profile/Profile'
import Myself_ from './routes/Dashboard/Myself/Myself'
import Organization_ from './routes/Dashboard/Organization/Organization'
import SOTarget_ from './routes/Dashboard/SOTarget/SOTarget'
import Company_ from './routes/Dashboard/Company/company'
import All_ from './routes/Dashboard/All/All'
import ObserveType_ from './routes/Dashboard/ObserveType/ObserveType'
import Y2DObseveType_ from './routes/Dashboard/Y2DObserveType/Y2DObserveType'
import Y2DJobType_ from './routes/Dashboard/Y2DJobType/Y2DJobType'
import AboutUs_ from './routes/About_Us/AboutUs'
import SOHandbook_ from './routes/SOHandbook/SOHandbook'
import CompanyAdmin_ from './routes/Companyadmin/Companyadmin'
import Manual_ from './routes/manual/manual'
import JobTypeMaster_ from './routes/Master/JobType/JobType'
import CategoryMaster_ from './routes/Master/Category/Category'
import RootCauseMaster_ from './routes/Master/RootCause/RootCause'
import Capa_ from './routes/Capa'
import CapaManager_ from './routes/CapaManager'
import CapaAssignee_ from './routes/CapaAssignee'

export const WrappedLogin = WrappedLogin_;
export const MyOb1 = MyOb1_;
export const Summary = Summary_;
export const Feedback_myself = Feedback_myself_;
export const Feedbackdetail = Feedbackdetail_;
export const Feedback_new = Feedback_new_;
export const UserMD = UserMD_;
export const Newobservation_Basic_Info = Newobservation_Basic_Info_;
export const Newobservation_Checklist = Newobservation_Checklist_;
export const Newobservation_Category = Newobservation_Category_;
export const Newobservation_Action = Newobservation_Action_;
export const Newobservation_Summary = Newobservation_Summary_;
export const Profile = Profile_;
export const Myself = Myself_;
export const Feedback_all = Feedback_all_;
export const All = All_;
export const ObserveType = ObserveType_;
export const Y2DObseveType = Y2DObseveType_;
export const Y2DJobType = Y2DJobType_;
export const Organization = Organization_;
export const SOTarget = SOTarget_;
export const AboutUs = AboutUs_;
export const SOHandbook = SOHandbook_;
export const Companyadmin = CompanyAdmin_;
export const Manual = Manual_;
export const Company = Company_;
export const JobTypeMaster = JobTypeMaster_;
export const CategoryMaster = CategoryMaster_;
export const RootCauseMaster = RootCauseMaster_;
export const Capa = Capa_;
export const CapaManager = CapaManager_;
export const CapaAssignee = CapaAssignee_;